import ROLES from "../routes/Roles";

const {
  SUPER_ADMIN,
  TIMESHEET_EMPLOYEE,
  TIMESHEET_MANAGER,
  HR_MANAGER,
  PMO_USER,
  TIMESHEET_ADMIN,
  GUEST_EMPLOYEE,
  DASHBOARD_VIEWER,
  ALLOCATION_ADMIN,
  ALLOCATION_VIEWER,
  ESTIMATION_ADMIN,
  ESTIMATION_VIEWER,
  PRICING_ADMIN,
  PRICING_VIEWER,
  SOW_ADMIN,
  SOW_VIEWER,
  PO_ADMIN,
  PO_VIEWER,
  MILESTONE_ADMIN,
  MILESTONE_VIEWER,
  VIEWER,
  CLIENT_ADMIN,
  CLIENT_VIEWER,
  TIMESHEET_EXPORT_USER,
  RESOURCE_VIEWER,
  INVOICE_ADMIN,
  INVOICE_VIEWER,
  BUDGET_VIEWER,
  BUDGET_ADMIN,
  PROXY_TS_USER,
   EMPLOYEE_MANAGEMENT_VIEWER,
  EMPLOYEE_MANAGEMENT_ADMIN,

  ASSET_ADMIN,
  ASSET_VIEWER,
} = ROLES;

export const accessibleFeatures = {
  timesheet: {
    timesheetManagerTab: [
      TIMESHEET_MANAGER,
      GUEST_EMPLOYEE,
      SUPER_ADMIN,
      HR_MANAGER,
      PMO_USER,
      TIMESHEET_ADMIN
    ],
    managerWithEmployeeTable: [SUPER_ADMIN, HR_MANAGER, PMO_USER],
    terminateEmployee: [PMO_USER],
    approveContractTimesheet: [TIMESHEET_MANAGER, GUEST_EMPLOYEE],
    approveAnyTimesheet: [TIMESHEET_ADMIN],
    approveUnplannedTimeoff: [HR_MANAGER],
    getTimesheetApprovalsCount: [
      TIMESHEET_MANAGER,
      GUEST_EMPLOYEE,
      HR_MANAGER,
      TIMESHEET_ADMIN
    ],
    proxyTimesheets: [PROXY_TS_USER]
  },
  sidebar: {
    dashboard: [DASHBOARD_VIEWER, SUPER_ADMIN],
    clientManagement: [
      SUPER_ADMIN,
      ALLOCATION_ADMIN,
      ALLOCATION_VIEWER,
      ESTIMATION_ADMIN,
      ESTIMATION_VIEWER,
      PRICING_ADMIN,
      PRICING_VIEWER,
      SOW_ADMIN,
      SOW_VIEWER,
      PO_ADMIN,
      PO_VIEWER,
      MILESTONE_ADMIN,
      MILESTONE_VIEWER,
      VIEWER,
      CLIENT_ADMIN,
      CLIENT_VIEWER
    ],
    budgetManagement: [
      SUPER_ADMIN,
      ALLOCATION_ADMIN,
      ALLOCATION_VIEWER,
      ESTIMATION_ADMIN,
      ESTIMATION_VIEWER,
      PRICING_ADMIN,
      PRICING_VIEWER,
      SOW_ADMIN,
      SOW_VIEWER,
      PO_ADMIN,
      PO_VIEWER,
      MILESTONE_ADMIN,
      MILESTONE_VIEWER,
      VIEWER,

      BUDGET_VIEWER,
      BUDGET_ADMIN
    ],
    rateCard: [SUPER_ADMIN, ESTIMATION_ADMIN, PRICING_ADMIN],
    resourceManagement: [RESOURCE_VIEWER, SUPER_ADMIN],
    resourceMetrics: [RESOURCE_VIEWER, SUPER_ADMIN],
    resourceUtilization: [RESOURCE_VIEWER, SUPER_ADMIN],
    resourceInsights: [RESOURCE_VIEWER, SUPER_ADMIN],
    timesheets: [],
    managerView: [
      TIMESHEET_MANAGER,
      GUEST_EMPLOYEE,
      SUPER_ADMIN,
      HR_MANAGER,
      PMO_USER,
      TIMESHEET_ADMIN,
      PROXY_TS_USER
    ],
    budgetoReports: [SUPER_ADMIN, TIMESHEET_EXPORT_USER, HR_MANAGER, PMO_USER],
    settings: [SUPER_ADMIN],
    rateCardConfig: [SUPER_ADMIN],
    invoicesConfig: [SUPER_ADMIN, INVOICE_ADMIN],
    skillPayrateConfig: [SUPER_ADMIN],
    customerAccess: [SUPER_ADMIN],
    employeeManagement: [SUPER_ADMIN, EMPLOYEE_MANAGEMENT_VIEWER,
  EMPLOYEE_MANAGEMENT_ADMIN],
    assetManagement: [SUPER_ADMIN],
    employeeManagement: [SUPER_ADMIN],
    assetManagement: [SUPER_ADMIN,ASSET_ADMIN,ASSET_VIEWER],
    clientDetail: [
      SUPER_ADMIN,
      ALLOCATION_ADMIN,
      ALLOCATION_VIEWER,
      ESTIMATION_ADMIN,
      ESTIMATION_VIEWER,
      PRICING_ADMIN,
      PRICING_VIEWER,
      SOW_ADMIN,
      SOW_VIEWER,
      PO_ADMIN,
      PO_VIEWER,
      MILESTONE_ADMIN,
      MILESTONE_VIEWER,
      VIEWER,
      CLIENT_ADMIN,
      CLIENT_VIEWER
    ],
    budgetDetail: [
      SUPER_ADMIN,
      ALLOCATION_ADMIN,
      ALLOCATION_VIEWER,
      ESTIMATION_ADMIN,
      ESTIMATION_VIEWER,
      PRICING_ADMIN,
      PRICING_VIEWER,
      SOW_ADMIN,
      SOW_VIEWER,
      PO_ADMIN,
      PO_VIEWER,
      MILESTONE_ADMIN,
      MILESTONE_VIEWER,
      VIEWER,

      BUDGET_VIEWER,
      BUDGET_ADMIN
    ],
    estimation: [
      ESTIMATION_ADMIN,
      ESTIMATION_VIEWER,
      PRICING_ADMIN,
      PRICING_VIEWER,
      SUPER_ADMIN,
      VIEWER
    ],
    effortEstimation: [
      ESTIMATION_ADMIN,
      ESTIMATION_VIEWER,
      SUPER_ADMIN,
      VIEWER
    ],
    pricing: [PRICING_ADMIN, PRICING_VIEWER, SUPER_ADMIN, VIEWER],
    contracts: [
      SOW_ADMIN,
      SOW_VIEWER,
      MILESTONE_ADMIN,
      MILESTONE_VIEWER,
      PO_ADMIN,
      PO_VIEWER,
      SUPER_ADMIN,
      VIEWER
    ],
    contractDetails: [SOW_ADMIN, SOW_VIEWER, SUPER_ADMIN, VIEWER],
    milestones: [MILESTONE_ADMIN, MILESTONE_VIEWER, SUPER_ADMIN, VIEWER],
    purchaseOrders: [PO_ADMIN, PO_VIEWER, SUPER_ADMIN, VIEWER],
    allocations: [ALLOCATION_ADMIN, ALLOCATION_VIEWER, SUPER_ADMIN, VIEWER],
    invoices: [INVOICE_ADMIN, INVOICE_VIEWER, SUPER_ADMIN, VIEWER],
    insights: [SUPER_ADMIN, DASHBOARD_VIEWER]
  },
  buttons: {
    add: {
      addClient: [CLIENT_ADMIN, SUPER_ADMIN],
      addBudget: [BUDGET_ADMIN, SUPER_ADMIN],
      addEstimation: [SUPER_ADMIN, ESTIMATION_ADMIN],
      addPricing: [SUPER_ADMIN, PRICING_ADMIN],
      addRequisition: [SUPER_ADMIN, PRICING_ADMIN],
      addContract: [SUPER_ADMIN, SOW_ADMIN],
      addApproval: [SUPER_ADMIN, SOW_ADMIN],
      addMilestone: [SUPER_ADMIN, MILESTONE_ADMIN],
      addSchedule: [SUPER_ADMIN, MILESTONE_ADMIN],
      addAllocation: [SUPER_ADMIN, ALLOCATION_ADMIN],
      addSkillPayrate: [SUPER_ADMIN],
      addCustomer: [SUPER_ADMIN],
      addEmployee: [SUPER_ADMIN,  EMPLOYEE_MANAGEMENT_ADMIN],
      generateInvoice: [SUPER_ADMIN, INVOICE_ADMIN],
      addAsset: [SUPER_ADMIN, ASSET_ADMIN],
      generateActual: [SUPER_ADMIN, INVOICE_ADMIN],
      addInvoiceTemplate: [SUPER_ADMIN, INVOICE_ADMIN]
    },
    edit: {
      editEstimation: [ESTIMATION_ADMIN, SUPER_ADMIN],
      editPricing: [SUPER_ADMIN, PRICING_ADMIN],
      editContracts: [SUPER_ADMIN, SOW_ADMIN],
      editClient: [SUPER_ADMIN, CLIENT_ADMIN],
      editBudget: [SUPER_ADMIN, BUDGET_ADMIN],
      editAllocation: [ALLOCATION_ADMIN, SUPER_ADMIN],
      editMilestone: [MILESTONE_ADMIN, SUPER_ADMIN],
      editAsset: [SUPER_ADMIN, ASSET_ADMIN],
      editPO: [PO_ADMIN, SUPER_ADMIN],
      editSkillPayrate: [SUPER_ADMIN],
      editCustomer: [SUPER_ADMIN],
      editEmployee: [SUPER_ADMIN, EMPLOYEE_MANAGEMENT_ADMIN]
    },
    delete: {
      deleteClient: [CLIENT_ADMIN, SUPER_ADMIN],
      deleteAsset: [SUPER_ADMIN, ASSET_ADMIN],
      deleteBudget: [BUDGET_ADMIN, SUPER_ADMIN],
      deleteEstimation: [ESTIMATION_ADMIN, SUPER_ADMIN],
      deletePricing: [PRICING_ADMIN, SUPER_ADMIN],
      deleteContracts: [SOW_ADMIN, SUPER_ADMIN],
      deleteAllocation: [ALLOCATION_ADMIN, SUPER_ADMIN],
      deleteMilestone: [MILESTONE_ADMIN, SUPER_ADMIN],
      deletePO: [PO_ADMIN, SUPER_ADMIN],
      deleteSkillPayrate: [SUPER_ADMIN],
      deleteCustomer: [SUPER_ADMIN],
      deleteEmployee: [SUPER_ADMIN],
      deleteSOftware: [SUPER_ADMIN],
      deleteInvoiceTemplate: [SUPER_ADMIN, INVOICE_ADMIN]
    }
  },
  purchaseOrders: {
    addPurchaseOrder: [SUPER_ADMIN, PO_ADMIN],
    assignContract: [SUPER_ADMIN, PO_ADMIN],
    addBudgetOrder: [SUPER_ADMIN, PO_ADMIN],
    assignBudget: [SUPER_ADMIN, PO_ADMIN]
  },
  accessBasedGuard: {
    clientDetails: [
      SUPER_ADMIN,
      VIEWER,
      CLIENT_VIEWER,
      CLIENT_ADMIN,
      ESTIMATION_VIEWER,
      ESTIMATION_ADMIN,
      PRICING_VIEWER,
      PRICING_ADMIN,
      SOW_VIEWER,
      SOW_ADMIN,
      MILESTONE_VIEWER,
      MILESTONE_ADMIN,
      PO_VIEWER,
      PO_ADMIN,
      ALLOCATION_VIEWER,
      ALLOCATION_ADMIN,
      INVOICE_VIEWER,
      INVOICE_ADMIN
    ],
    budgetDetails: [
      SUPER_ADMIN,
      VIEWER,

      ESTIMATION_VIEWER,
      ESTIMATION_ADMIN,
      PRICING_VIEWER,
      PRICING_ADMIN,
      SOW_VIEWER,
      SOW_ADMIN,
      MILESTONE_VIEWER,
      MILESTONE_ADMIN,
      PO_VIEWER,
      PO_ADMIN,
      ALLOCATION_VIEWER,
      ALLOCATION_ADMIN,
      INVOICE_VIEWER,
      INVOICE_ADMIN,
      BUDGET_VIEWER,
      BUDGET_ADMIN
    ],
    rateCard: [SUPER_ADMIN, ESTIMATION_ADMIN, PRICING_ADMIN],
    dashboardPage: [SUPER_ADMIN, VIEWER, DASHBOARD_VIEWER],
    estimation: [ESTIMATION_VIEWER, VIEWER, ESTIMATION_ADMIN, SUPER_ADMIN],
    pricingEstimation: [VIEWER, PRICING_VIEWER, PRICING_ADMIN, SUPER_ADMIN],
    contracts: [VIEWER, SOW_ADMIN, SOW_VIEWER, SUPER_ADMIN],
    contractMilestones: [
      VIEWER,
      MILESTONE_ADMIN,
      MILESTONE_VIEWER,
      SUPER_ADMIN
    ],
    contractPurchaseOrder: [VIEWER, PO_ADMIN, PO_VIEWER, SUPER_ADMIN],
    allocation: [VIEWER, ALLOCATION_ADMIN, ALLOCATION_VIEWER, SUPER_ADMIN],
    invoicing: [INVOICE_VIEWER, INVOICE_ADMIN, SUPER_ADMIN, VIEWER],
    insights: [SUPER_ADMIN, DASHBOARD_VIEWER],
    resourcesManagement: [RESOURCE_VIEWER, SUPER_ADMIN, VIEWER],
    setting: [SUPER_ADMIN],
    employeeSettings: [SUPER_ADMIN],
    invoiceSettings: [SUPER_ADMIN, INVOICE_ADMIN]
  },
  defaultRedirection: {
    dashboardPage: [DASHBOARD_VIEWER],
    resourcesManagementPage: [RESOURCE_VIEWER]
  }
};
